import {nonGroupedValues} from "@common/FilterComponent";
import {
  ADMITTED,
  CLOSED,
  DECEASED,
  DISCHARGED,
  ENDED_HHA_SERVICES,
  ENDED_SERVICES,
  MEDICAL_LEAVE_OF_ABSENCE,
  PAYOR_CHANGED,
  PingTags,
  PRESENTED,
  RESUMED_SERVICES,
  STARTED_HHA_SERVICES,
  TRANSFERRED,
  VISIT
} from "@manual_encounters/constants/PingStatuses";

export const EVENT_TYPES : nonGroupedValues[] = [
  {id: "ADT", value: "ADT", label: "ADT"},
  {id: "REFERRAL",value: "REFERRAL", label: "Openbeds referral"},
  {id: "CRISIS",value: "CRISIS", label: "Openbeds Crisis"},
  {id: "SDOH",value: "SDOH", label: "SDOH referral"},
  {id: "JI",value: "JI", label: "Justice Involved"}
];

export const ADTEventStatuses: nonGroupedValues[]  = [
  { id: PingTags[ADMITTED], value: PingTags[ADMITTED], label: PingTags[ADMITTED] },//used in notifications event status
  { id: PingTags[PRESENTED], value: PingTags[PRESENTED], label: PingTags[PRESENTED] },//used in notifications event status
  { id: PingTags[VISIT], value: PingTags[VISIT], label: PingTags[VISIT] },
  { id: PingTags[DISCHARGED], value: PingTags[DISCHARGED], label: PingTags[DISCHARGED] },//used in notifications event status
  { id: PingTags[DECEASED], value: PingTags[DECEASED], label: PingTags[DECEASED] },//used in notifications event status
  { id: PingTags[TRANSFERRED], value: PingTags[TRANSFERRED], label: PingTags[TRANSFERRED] },//used in notifications event status
  { id: PingTags[CLOSED], value: PingTags[CLOSED], label: PingTags[CLOSED] },
  { id: PingTags[PAYOR_CHANGED], value: PingTags[PAYOR_CHANGED],
    label: PingTags[PAYOR_CHANGED] },//used in notifications event status
  { id: PingTags[MEDICAL_LEAVE_OF_ABSENCE], value: PingTags[MEDICAL_LEAVE_OF_ABSENCE],
    label: PingTags[MEDICAL_LEAVE_OF_ABSENCE] },
  { id: PingTags[RESUMED_SERVICES], value: PingTags[RESUMED_SERVICES], label: PingTags[RESUMED_SERVICES] },
  { id: PingTags[ENDED_SERVICES], value: PingTags[ENDED_SERVICES], label: PingTags[ENDED_SERVICES] },
  { id: PingTags[STARTED_HHA_SERVICES], value: PingTags[STARTED_HHA_SERVICES], label: PingTags[STARTED_HHA_SERVICES] },
  { id: PingTags[ENDED_HHA_SERVICES], value: PingTags[ENDED_HHA_SERVICES], label: PingTags[ENDED_HHA_SERVICES] },
];

export const CrisisEventStatuses = [
  { id: 'REQUESTED', value: 'REQUESTED', label: 'REQUESTED' },//used in notifications event status
  { id: 'ACCEPTED', value: 'ACCEPTED', label: 'ACCEPTED' },
  { id: 'ACKNOWLEDGED', value: 'ACKNOWLEDGED', label: 'ACKNOWLEDGED' },
  { id: 'ARRIVED', value: 'ARRIVED', label: 'ARRIVED' },//used in notifications event status
  { id: 'DEPARTED', value: 'DEPARTED', label: 'DEPARTED' },
  { id: 'DECLINED', value: 'DECLINED', label: 'DECLINED' },
  { id: 'CANCELLED', value: 'CANCELLED', label: 'CANCELLED' },//used in notifications event status
  { id: 'CLOSED', value: 'CLOSED', label: 'CLOSED' },
  { id: 'COMPLETED', value: 'COMPLETED', label: 'COMPLETED' },//used in notifications event status
  { id: 'TRANSFER_PENDING', value: 'TRANSFER_PENDING', label: 'TRANSFER_PENDING' },//used in notifications event status
];

export const ReferralEventStatuses = [
  { id: 'ACCEPTED', value: 'ACCEPTED', label: 'ACCEPTED' },//used in notifications event status
  { id: 'CLOSED', value: 'CLOSED', label: 'CLOSED' },//used in notifications event status
  { id: 'DECLINED', value: 'DECLINED', label: 'DECLINED' },//used in notifications event status
  { id: 'NEW_REFERRAL', value: 'NEW_REFERRAL', label: 'NEW_REFERRAL' },//used in notifications event status
  { id: 'OPENED', value: 'OPENED', label: 'OPENED' },//used in notifications event status
  { id: 'PENDING', value: 'PENDING', label: 'PENDING' },//used in notifications event status
  { id: 'WAITLISTED', value: 'WAITLISTED', label: 'WAITLISTED' },//used in notifications event status
];

export const SDOHEventStatuses = [
  { id: 'NEW_REFERRAL', value: 'NEW_REFERRAL', label: 'NEW_REFERRAL' },
  { id: 'PENDING', value: 'PENDING', label: 'PENDING' },
  { id: 'ACCEPTED', value: 'ACCEPTED', label: 'ACCEPTED' },
  { id: 'DECLINED', value: 'DECLINED', label: 'DECLINED' },
];

export const JIEventStatuses = [
  { id: 'ACKNOWLEDGED', value: 'ACKNOWLEDGED', label: 'ACKNOWLEDGED' },//used in notifications event status
  { id: 'BOOKED', value: 'BOOKED', label: 'BOOKED' },//used in notifications event status
  { id: 'DEPARTED', value: 'DEPARTED', label: 'DEPARTED' },//used in notifications event status
  { id: 'OPEN', value: 'OPEN', label: 'OPEN' },//used in notifications event status
  { id: 'RELEASED', value: 'RELEASED', label: 'RELEASED' },//used in notifications event status
];

export const PingFlags: nonGroupedValues[] = [
  {id: "High utilizer", value: "High utilizer", label: "High utilizer"},
  {id: "Readmission Risk", value: "Readmission Risk", label: "Readmission Risk"},
  {id: "Recent SNF Stay", value: "Recent SNF Stay", label: "Recent SNF Stay"},
  {id: "Recent Inpatient Stay", value: "Recent Inpatient Stay", label: "Recent Inpatient Stay"},
];

export const EventStatuesMap: Record<typeof EVENT_TYPES[number]['value'], nonGroupedValues[]> = {
  ADT: ADTEventStatuses,
  REFERRAL: ReferralEventStatuses,
  CRISIS: CrisisEventStatuses,
  SDOH: SDOHEventStatuses,
  JI: JIEventStatuses
};

export const hasDischargeSummary=[
  {
    "label": "Yes",
    "value": true
  }
  , {
    "label": "No",
    "value": false
  }
];

export const EventSettings: string[] = [
  'ACUTE',
  'Assisted_Living',
  'BLANK',
  'Emergency',
  'Home',
  'HOSPICE',
  'INDEPENDENT_LIVING',
  'Inpatient',
  'LONG_TERM_ACUTE_CARE',
  'LONG_TERM_CARE',
  'MEMORY',
  'NA',
  'NonSkilled',
  'Observation',
  'RESPITE',
  'Skilled',
  'Unknown',
  'URGENT_CARE'
];
